import axios from 'axios';

export const request = axios.create();

export default request;
